import React, { memo } from 'react';
import { IconHelper } from 'components/generic/IconHelper';

export type AssetTypeIconCellProps = {
  type?: string | null | undefined;
};

/**
 * AssetTypeIconCell - Displays an icon representing the asset type
 *
 * Re-used in collections and other asset list components.
 */
export const AssetTypeIconCell = memo(({ type }: AssetTypeIconCellProps) => {
  if (!type) {
    return null;
  }

  return <IconHelper iconType={type} />;
});
AssetTypeIconCell.displayName = 'AssetTypeIconCell';
